/* eslint-disable import/prefer-default-export */
import { keyframes } from 'styled-components';

export const spinnerRotate = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(270deg);
  }
`;

export const spinnerDash = offset => keyframes`
  0% {
    stroke-dashoffset: ${offset};
  }

  50% {
    stroke-dashoffset: ${offset / 4};
    transform: rotate(135deg);
  }

  100% {
    stroke-dashoffset: ${offset};
    transform: rotate(450deg);
  }
`;
